import * as Yup from 'yup';
// eslint-disable-next-line no-restricted-imports
import { type DesignerProps } from '@webinex/dynamic-form';
import { Form } from '@webinex/antik';

interface FormDynamicElementsResult {
  DESIGNER_ELEMENTS: DesignerProps['Elements'];
  ELEMENTS: any[];
  RichTextElement: any;
}

function importAsync(): Promise<FormDynamicElementsResult> {
  return import('@webinex/dynamic-form').then(({ createElement, DesignerUtil, ELEMENTS }) => {
    const RichTextElement = createElement({
      id: 'RichText',
      title: 'Rich Text',
      value: ['arrayOf', 'object'],
      props: Yup.object({
        label: Yup.string().nullable().label('Title').default('Rich Text').required(),
        disabled: Yup.boolean().label('Disabled').meta({ control: 'expression' }),
      }),
      Component: ({ label, name, required, disabled: disabledProp }) => {
        const disabled = Form.useDisabled(disabledProp);

        return (
          <Form.Item label={label} name={name} required={required} layout="vertical">
            <Form.RichTextArea readonly={disabled} />
          </Form.Item>
        );
      },
    });

    const DESIGNER_ELEMENTS: DesignerProps['Elements'] = ELEMENTS.map((group) => {
      if (group[0] === 'Form') {
        const [groupId, ...elements] = group;
        return [groupId, ...elements, RichTextElement];
      }

      return group;
    }) as DesignerProps['Elements'];

    const ELEMENTS_FLAT = DesignerUtil.flattenElements(DESIGNER_ELEMENTS);

    return {
      DESIGNER_ELEMENTS,
      ELEMENTS: ELEMENTS_FLAT,
      RichTextElement,
    };
  });
}

export const FormDynamicElements = {
  import: importAsync,
  Elements: () => importAsync().then((x) => x.ELEMENTS),
  DesignerElements: () => importAsync().then((x) => x.DESIGNER_ELEMENTS),
};
